/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface BaseResponse {
  /** sub code */
  code?: number;
  /** information for the response */
  msg?: string;
  data?: object;
  errors?: Error[];
}

export interface Error {
  /** error type, eg. Generic, InvalidRequest, ClientForbidden */
  reason?: string;
  /** human-friendly message */
  detail?: string;
  /** chart */
  location?: string;
  /** parameter */
  locationType?: string;
}

export interface NFT {
  /** nft name */
  name?: string;
  /** nft link for opensocial */
  external_url?: string;
  /** nft image url, ipfs link */
  image?: string;
  /** nft animation url, ipfs link */
  animation_url?: string;
  /** nft desc */
  description?: string;
  attributes?: Record<string, object>;
}

export interface RecipientPercent {
  /** recipient contract address */
  recipient?: string;
  /**
   * should be between 1 and 100
   * @format float
   */
  percent?: number;
}

export interface JoinModule {
  /** join module enum */
  type: JoinModuleEnum;
  /** join module */
  init?: {
    null_join_module?: object;
    erc20_fee_join_module?: ERC20FeeJoinModule;
    native_fee_join_module?: NativeFeeJoinModule;
    hold_token_join_module?: HoldTokenJoinModule;
  };
}

export interface ERC20FeeJoinModule {
  /** currency contract address */
  currency_address?: string;
  /** It could have the entire precision of the Asset or be truncated to the last significant decimal */
  amount_uint?: string;
  /** The follow module recipient address */
  recipient_address?: string;
}

export interface NativeFeeJoinModule {
  /** It could have the entire precision of the Asset or be truncated to the last significant decimal */
  amount_uint?: string;
  /** The join module recipient address */
  recipient_address?: string;
}

export interface HoldTokenJoinModule {
  /** token contract address */
  token_address?: string;
  amount_uint?: string;
}

/** join module enum */
export enum JoinModuleEnum {
  NULL_JOIN_MODULE = "NULL_JOIN_MODULE",
  ERC20FEEJOINMODULE = "ERC20_FEE_JOIN_MODULE",
  HOLD_TOKEN_JOIN_MODULE = "HOLD_TOKEN_JOIN_MODULE",
  NATIVE_FEE_JOIN_MODULE = "NATIVE_FEE_JOIN_MODULE",
}

/** join module parameter */
export interface JoinModuleParam {
  /** join module enum */
  type: JoinModuleEnum;
  /** You only have to enter one  */
  data?: {
    null_join_module?: object;
    erc20_fee_join_module?: FeeModuleParamData;
    native_fee_join_module?: object;
    hold_token_join_module?: object;
  };
}

export interface FeeModuleParamData {
  /** currency contract address */
  currency_address?: string;
  /** It could have the entire precision of the Asset or be truncated to the last significant decimal */
  amount_uint?: string;
}

export interface Broadcast {
  tx_hash: string;
}

export type BroadcastResponse = BaseResponse & {
  data?: Broadcast;
};

export interface BroadcastRequest {
  id: string;
  signature: string;
}

export interface SyncRequest {
  tx_hash?: string;
  topic?: string;
  index_id?: string;
  off_chain_id?: string;
  chain_id?: string;
  status?: "SUCCESS" | "FAIL" | "BEGIN";
}

export type TransactionResponse = BaseResponse & {
  data?: {
    /** txHash if success */
    tx_hash?: string;
    /** txId if indexed by relay */
    tx_id?: string;
    info?: object;
  };
};

export interface UserOperation {
  sender?: string;
  nonce?: string;
  init_code?: string;
  call_data?: string;
  call_gas_limit?: string;
  verification_gas_limit?: string;
  pre_verification_gas?: string;
  max_fee_per_gas?: string;
  max_priority_fee_per_gas?: string;
  paymaster_and_data?: string;
  signature?: string;
  policy_data?: string;
}

export type FillUserOperationResponse = BaseResponse & {
  data?: UserOperation;
};

export type EstimateUserOperationResponse = BaseResponse & {
  data?: string;
};

/** device type enum */
export enum BaseMetaTypeEnum {
  Profile = "profile",
  Community = "community",
}

export interface Media {
  /** id for resource */
  id?: string;
  /** media url */
  display_url?: string;
  /** media url */
  media_url?: string;
  /** http url */
  media_url_https?: string;
  /** mimeType of media format, image/gif ,video/mp4, audio/mp3 */
  type?: string;
  /** native/twitter/giphy */
  source?: string;
  /** link */
  link?: string;
  /** url */
  url?: string;
  /** json format sizes */
  sizes?: string;
  /** extra cover url */
  extra?: string;
}

/** sync status enum */
export enum SyncStatus {
  UNSYNC = "UNSYNC",
  SYNCING = "SYNCING",
  SYNCED = "SYNCED",
}

/** post type enum */
export enum OperateTypeEnum {
  DRAFT = "DRAFT",
  INDEX = "INDEX",
}

export interface Url {
  /** url */
  url?: string;
  /** og or twitter title */
  title?: string;
  /** og or twitter description */
  description?: string;
  /** og or twitter image */
  image?: string;
}

export interface Mention {
  /** profileId */
  profileId?: string;
  /** ospAddress */
  osp_address?: string;
  /** user handle */
  handle?: string;
}

export interface Challenge {
  /** text to sign */
  text?: string;
}

export type ChallengeResponse = BaseResponse & {
  data?: Challenge;
};

export interface Token {
  /** 30 minutes access token */
  access_token?: string;
  /** 7 days refresh token */
  refresh_token?: string;
}

export type TokenResponse = BaseResponse & {
  data?: Token;
};

export interface AuthRequest {
  /** sign message by challenge text */
  signature: string;
  /** address */
  eoa_address?: string;
}

/** ThirdAuthSource */
export enum ThirdAuthSourceEnum {
  EXTERNAL_WALLET = "EXTERNAL_WALLET",
  EXTERNAL_SOCIAL = "EXTERNAL_SOCIAL",
}

export interface IdToken {
  /** the user identifier token */
  id_token?: string;
}

export type IdTokenResponse = BaseResponse & {
  data?: IdToken;
};

/** Owner info */
export interface Owner {
  /** id */
  id?: string;
  /** osp_address */
  osp_address?: string;
  /** eoa_address */
  eoa_address?: string;
  /** issue_channel */
  issue_channel?: string;
  /** issue_platform */
  issue_platform?: string;
  /** handle */
  issue_name?: string;
  /** transaction status */
  status?: OwnerStatusEnum;
  /** app_id */
  app_id?: string;
}

export type OwnerResponse = BaseResponse & {
  /** Owner info */
  data?: Owner;
};

export interface OwnerPagination {
  /**
   * 每次请求数
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * 返回的总页数，默认不查询总页数，返回0
   * @format int32
   */
  total?: number;
  /** 翻页token */
  next_token?: string;
  rows?: Owner[];
}

export type OwnerPaginationResponse = BaseResponse & {
  data?: OwnerPagination;
};

/** transaction status */
export enum OwnerStatusEnum {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export interface Activity {
  /** profile info */
  profile?: Profile;
  /** IPFS url */
  content_uri?: string;
  title?: string;
  text?: string;
  summary?: string;
  profile_id?: string;
  view_id?: string;
  /** chain content id */
  content_id?: string;
  /** @format int64 */
  created?: number;
  /** @format int64 */
  share_count?: number;
  /** @format int64 */
  like_count?: number;
  /** @format int64 */
  comment_count?: number;
  /** @format int64 */
  reply_count?: number;
  /** @format int64 */
  favorite_count?: number;
  /** @format int64 */
  view_count?: number;
  /** @format int64 */
  upvote_count?: number;
  /** @format int64 */
  downvote_count?: number;
  community_id?: string;
  /** index id ,use mark data */
  index_id?: string;
  /** sync status */
  sync_status?: SyncStatus;
  medias?: Media[];
  urls?: Url[];
  mentions?: Mention[];
  /** content */
  content?: string;
  /** reference_condition */
  reference_condition?: string;
}

export type ActivityResponse = BaseResponse & {
  data?: Activity;
};

export interface ActivityPagination {
  /**
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** @format int32 */
  total?: number;
  next_token?: string;
  rows?: Activity[];
}

export type ActivityPaginationResponse = BaseResponse & {
  data?: ActivityPagination;
};

export interface AddActivityRequest {
  /** The hexadecimal community id */
  community_id?: string;
  /**
   * The metadata uploaded somewhere passing in the url to reach it, by
   * @format uri
   */
  content_uri?: string;
  /** content_uri include info JSON to string */
  content?: string;
}

/** activity category */
export enum ActivityCategoryEnum {
  POST = "POST",
  QUESTION = "QUESTION",
  POLL = "POLL",
}

/** feed ranking enum */
export enum ActivityRankingEnum {
  ACTIVITY_TIME = "ACTIVITY_TIME",
  TOP_COLLECTED = "TOP_COLLECTED",
  TOP_COMMENTED = "TOP_COMMENTED",
  TOP_REPOSTED = "TOP_REPOSTED",
}

export interface GetActivitiesRequest {
  /**
   * The amount of activities requested from the APIs
   * @format int32
   */
  limit?: number;
  /** nextToken */
  next_token?: string;
  /** filter activity category */
  categories?: ActivityCategoryEnum[];
  /** exclude profile ids */
  exclude_profile_ids?: string[];
  /** turn on or off randomizer, not supported */
  randomize?: boolean;
  /** feed ranking enum */
  ranking?: ActivityRankingEnum;
  /** The app_ids Ids */
  app_ids?: string[];
  /**
   * The timestamp
   * @format int64
   */
  timestamp?: number;
  /** content_id */
  content_id?: string;
  /** profile_id */
  profile_id?: string;
}

export interface UpdateActivityRequest {
  /**
   * tag id
   * @maxItems 5
   */
  tags?: string[];
}

/** activity category */
export enum CategoryEnum {
  POST = "POST",
  ANSWER = "ANSWER",
  QUESTION = "QUESTION",
}

export interface EnrichOption {
  /** 是否开启enrich */
  enrich?: boolean;
  /** 是否携带最近的互动信息 */
  with_recent_reactions?: boolean;
  /**
   * 每次携带的互动信息数量
   * @min 0
   * @max 20
   */
  recent_reactions_limit?: number;
  /** 是否携带操作人的互动关系 */
  with_own_reactions?: boolean;
  /** 携带child信息 */
  with_own_children?: boolean;
  /** 是否携带互动数 */
  with_reaction_counts?: boolean;
  /** 需要携带的互动类型 */
  reaction_kinds_filter?: ReactionKindEnum[];
  /**
   * 是否返回创建者信息
   * @example false
   */
  with_profile?: boolean;
  /**
   * 是否返回板块信息
   * @example false
   */
  with_community?: boolean;
  /** 需要查询的与当前登录用户的relation */
  with_relations?: RelationEnum[];
}

export interface Feed {
  /** display content id */
  view_id?: string;
  /** chain content id */
  content_id?: string;
  /** profile id */
  profile_id?: string;
  /** activity status */
  status?: FeedStatusEnum;
  /** activity category */
  category?: CategoryEnum;
  /** 标题 */
  title?: string;
  /** 摘要内容 */
  summary?: string;
  /** 全文内容 */
  text?: string;
  medias?: Media[];
  /** 主题内容 */
  community_id?: string;
  /**
   * 创建时间
   * @format int64
   */
  created?: number;
  /**
   * 修改时间
   * @format int64
   */
  modified?: number;
  /**
   * 分享数
   * @format int64
   */
  share_count?: number;
  /**
   * 点赞数
   * @format int64
   */
  like_count?: number;
  /**
   * 评论数
   * @format int64
   */
  comment_count?: number;
  /**
   * 回复数
   * @format int64
   */
  reply_count?: number;
  /**
   * 收藏数
   * @format int64
   */
  favorite_count?: number;
  /**
   * 浏览数
   * @format int64
   */
  view_count?: number;
  /**
   * 同意数
   * @format int64
   */
  upvote_count?: number;
  /**
   * 反对数
   * @format int64
   */
  downvote_count?: number;
  /** 是否屏蔽了该创建者 */
  blocking?: boolean;
  /** 是否关注了该创建者 */
  following?: boolean;
  /** profile info */
  profile?: Profile;
  /** 最近互动列表 */
  recent?: Record<string, Reaction[]>;
  /** 是否产生过互动 */
  owns?: Record<string, Reaction>;
  activity?: Feed;
  /** community info */
  community?: Community;
  /** 登录用户与返回用户的关系 */
  relations?: RelationEnum[];
  /** index id ,use mark data */
  index_id?: string;
  /** sync status enum */
  sync_status?: SyncStatus;
  /** IPFS url */
  content_uri?: string;
  /**
   * megaphone count
   * @format int64
   */
  megaphone_count?: number;
  /** reference_condition */
  reference_condition?: string;
  urls?: Url[];
  mentions?: Mention[];
  /** content */
  content?: string;
  /** impression id */
  impression_id?: string;
  /** promoted id */
  promoted_id?: string;
}

export interface FeedPagination {
  /**
   * request data count
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * 返回的总页数，默认不查询总页数，返回0
   * @format int32
   */
  total?: number;
  /** 翻页token */
  nextToken?: string;
  rows?: Feed[];
}

export type FeedPaginationResponse = BaseResponse & {
  data?: FeedPagination;
};

export type FeedResponse = BaseResponse & {
  data?: Feed;
};

/** activity status */
export enum FeedStatusEnum {
  NORMAL = "NORMAL",
  INNER = "INNER",
  STOP = "STOP",
}

export interface ListFeedRequest {
  /**
   * The amount of activities requested from the APIs
   * @format int32
   */
  limit?: number;
  /** nextToken */
  next_token?: string;
  /**
   * 过滤掉的viewId
   * @maxItems 5
   */
  exclude_view_ids?: string[];
  /** communityId */
  community_id?: string;
  enrich_option?: EnrichOption;
  /** 标记已读 */
  mark_read?: boolean;
  /** feed params for flat */
  params?: Record<string, any>;
}

/** profile info */
export interface Profile {
  /** profile id */
  profile_id?: string;
  handle?: string;
  bio?: string;
  background?: string;
  /** picture(url,height/width/mimeType...) or NftImage(contractAddress,tokenId,uri) */
  avatar?: string;
  /** todo support? */
  metadata?: object;
  /** owner id */
  owner?: string;
  /** owner address */
  address?: string;
  attributes?: ProfileAttribute[];
  dispatcher?: Dispatcher;
  /** The follow Condition */
  follow_condition?: object;
  /** Follow nft address */
  follow_nft_address?: string;
  /**
   * 0=unfollow,1=off_chain follow, 2=on_chain follow
   * @format int64
   */
  following?: number;
  /** following token id */
  following_token_id?: string;
  /**
   * 0=unfollow,1=off_chain follow, 2=on_chain follow
   * @format int64
   */
  followed?: number;
  /** @format int64 */
  following_count?: number;
  /** @format int64 */
  chain_following_count?: number;
  /** @format int64 */
  follower_count?: number;
  /** @format int64 */
  chain_follower_count?: number;
  /** @format int64 */
  subscribe_count?: number;
  /** @format int64 */
  activity_count?: number;
  /** @format int64 */
  join_count?: number;
  /** @format int64 */
  activity_like_count?: number;
  /** index id ,use mark data */
  index_id?: string;
  /** displayName or nickName */
  nick_name?: string;
  /** @format int64 */
  created?: number;
  /** sync status enum */
  sync_status?: SyncStatus;
}

export interface ProfileAttribute {
  /** The display type */
  display_type?: string;
  /** identifier of this attribute, we will update by this id */
  key?: string;
  /** The trait type - can be anything its the name it will render so include spaces */
  trait_type?: string;
  /** Value attribute */
  value?: string;
}

export type ProfileResponse = BaseResponse & {
  /** profile info */
  data?: Profile;
};

export interface ProfilePagination {
  /**
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** @format int32 */
  total?: number;
  next_token?: string;
  rows?: Profile[];
}

export type ProfilePaginationResponse = BaseResponse & {
  data?: ProfilePagination;
};

export interface Dispatcher {
  /** wallet address of dispatcher */
  address?: string;
  /** use the built-in dispatcher on the API */
  canRelay?: boolean;
}

export interface ListProfileRequest {
  /** eoa address */
  eoa_address?: string;
  /** user owner wallet address */
  address?: string;
  /** user handle */
  handles?: string[];
  /** community id */
  community_id?: string;
  /** profile rank kind */
  ranking?: ProfileRankingEnum;
  /** user id */
  ids?: string[];
  /** nextToken for pagination */
  next_token?: string;
  /**
   * limit for pagination
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
}

/** profile rank kind */
export enum ProfileRankingEnum {
  RECOMMEND = "RECOMMEND",
}

/** Asset Info */
export interface Asset {
  /** contract address */
  contract_address?: string;
  /** token id */
  token_id?: string;
  /** chain id */
  chain_id?: number;
  nft?: NFT;
}

/** nft asset type */
export enum AssetTypeEnum {
  NFT = "NFT",
  JOIN_NFT = "JOIN_NFT",
  TRIBE_NFT = "TRIBE_NFT",
  SBT = "SBT",
}

export interface AssetPagination {
  /**
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** @format int32 */
  total?: number;
  next_token?: string;
  rows?: Asset[];
}

export type AssetPaginationResponse = BaseResponse & {
  data?: AssetPagination;
};

/** 查询动态列表 */
export interface ListStoryRequest {
  /**
   * @min 1
   * @max 20
   */
  limit?: number;
  next_token?: string;
  profile_id?: string;
  /** @maxItems 5 */
  zones?: string[];
}

/** 动态对象 */
export interface Story {
  /** 主键id */
  id?: string;
  /**
   * 创建时间
   * @format int64
   */
  created?: number;
  /** 点赞或者关注用户时链上id，为空代表链下操作 */
  content_id?: string;
  /** question status enum */
  verb?: StoryVerbEnum;
  activity?: Feed;
  reaction?: Feed;
  /** 回复 */
  child_reaction?: Feed;
  /** community info */
  community?: Community;
  /** profile info */
  profile?: Profile;
}

export interface StoryPagination {
  /**
   * 每次请求数
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * 返回的总页数，默认不查询总页数，返回0
   * @format int32
   */
  total?: number;
  /** 翻页token */
  next_token?: string;
  rows?: Story[];
}

export type StoryPaginationResponse = BaseResponse & {
  data?: StoryPagination;
};

/** question status enum */
export enum StoryVerbEnum {
  LIKE_POST = "LIKE_POST",
  COMMENT = "COMMENT",
  REPLY = "REPLY",
  FOLLOW = "FOLLOW",
  JOIN_COMMUNITY = "JOIN_COMMUNITY",
  CREATE_COMMUNITY = "CREATE_COMMUNITY",
}

export interface UpdateProfileRequest {
  /** nick_name */
  nick_name?: string;
  /** avatar */
  avatar?: string;
  /** background desc */
  background?: string;
  /** intro */
  intro?: string;
}

/** community info */
export interface Community {
  /** 社区id */
  id?: string;
  /** 社区唯一名 */
  handle?: string;
  /** display */
  display_name?: string;
  /** 描述 */
  desc?: string;
  /** banner url */
  banner?: string;
  /** template id */
  template?: string;
  /** 创建用户ID */
  profile_id?: string;
  /** logo */
  logo?: string;
  /**
   * 帖子数
   * @format int64
   */
  activity_count?: number;
  /**
   * 社区关注数
   * @format int64
   */
  member_count?: number;
  /** profile info */
  profile?: Profile;
  /** isJoining */
  joining?: boolean;
  /** @format int64 */
  modified?: number;
  /** @format int64 */
  draft_time?: number;
  /** join token id */
  join_token_id?: string;
  /** join_nft */
  join_nft?: string;
  nft?: NFT;
  tags?: CommunityTag[];
  /** bind domain name */
  domain?: string;
  /** template_body */
  template_body?: string;
  /** join condition details */
  join_condition_details?: object;
  /** is query from draft */
  is_draft?: boolean;
  /** community info */
  draft?: Community;
  /** language data */
  language?: string;
  /** token_id data */
  token_id?: string;
  rules?: string[];
  activity_tags?: string[];
  /** index id ,use mark data */
  index_id?: string;
  /** sync status enum */
  sync_status?: SyncStatus;
}

export interface CommunityPagination {
  /**
   * 每次请求数
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * 返回的总页数，默认不查询总页数，返回0
   * @format int32
   */
  total?: number;
  /** 翻页token */
  next_token?: string;
  rows?: Community[];
}

export type CommunityPaginationResponse = BaseResponse & {
  data?: CommunityPagination;
};

/** community ranking type */
export enum CommunityRankingEnum {
  ORDER = "ORDER",
  MODIFIED = "MODIFIED",
  CREATED = "CREATED",
  RECOMMEND = "RECOMMEND",
  DRAFT_TIME = "DRAFT_TIME",
  MEMBER_COUNT = "MEMBER_COUNT",
}

export type CommunityResponse = BaseResponse & {
  /** community info */
  data?: Community;
};

/** query communities */
export interface ListCommunityRequest {
  /** community ranking type */
  ranking: CommunityRankingEnum;
  /** query by custom domain/hostname */
  domain?: string;
  /** query by handle */
  handle?: string;
  /**
   * @min 1
   * @max 20
   */
  limit: number;
  next_token?: string;
  /**
   * community creator
   * @default false
   */
  with_profile?: boolean;
  profile_id?: string;
  /**
   * tag id
   * @maxItems 3
   */
  tag_ids?: string[];
  language?: string;
  /** search  join_condition_address */
  join_condition_address?: string;
}

export interface UpdateCommunityRequest {
  /** post type enum */
  type?: OperateTypeEnum;
  /** show name */
  display_name?: string;
  /** community desc */
  desc?: string;
  desc_medias?: Media[];
  /** logo url */
  logo?: string;
  /** banner url */
  banner?: string;
  /** language */
  language?: string;
  /** rules */
  rules?: string[];
  /** template id */
  template?: string;
  /** template 内容 */
  template_body?: string;
  /**
   * tag id
   * @maxItems 3
   */
  tags?: string[];
  /**
   * activity_tags
   * @maxItems 20
   */
  activity_tags?: string[];
  /** join condition detail for draft */
  join_condition_details?: object;
  token_id?: string;
  handle?: string;
}

export interface CommunityTag {
  /** tag id */
  id?: string;
  /** tag name */
  name?: string;
}

export interface CommunityTagPagination {
  /**
   * 每次请求数
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * 返回的总页数，默认不查询总页数，返回0
   * @format int32
   */
  total?: number;
  /** 翻页token */
  next_token?: string;
  rows?: CommunityTag[];
}

export type CommunityTagPaginationResponse = BaseResponse & {
  data?: CommunityTagPagination;
};

export interface CommunityEnrichOption {
  /**
   * 是否返回创建者信息
   * @example false
   */
  with_profile?: boolean;
  /** 需要查询的与当前登录用户的relation */
  with_relations?: RelationEnum[];
}

export interface AddReactionRequest {
  referenced_profile_id?: string;
  /**
   * display content id
   * @format string
   */
  referenced_view_id?: string;
  /**
   * The metadata uploaded somewhere passing in the url to reach it
   * @format uri
   */
  content_uri?: string;
  /** content_uri JSON to string */
  content?: string;
  /** reaction kind */
  kind?: ReactionKindEnum;
}

/** reaction kind */
export enum ReactionKindEnum {
  COMMENT = "COMMENT",
  REPLY = "REPLY",
  LIKE = "LIKE",
  SHARE = "SHARE",
  FAVORITE = "FAVORITE",
  VOTE = "VOTE",
  MEGAPHONE = "MEGAPHONE",
}

/** reaction kind */
export enum ReactionSubKindEnum {
  UPVOTE = "UPVOTE",
  DOWNVOTE = "DOWNVOTE",
}

/** reaction request */
export interface ListReactionRequest {
  /** reaction kind */
  kind?: ReactionKindEnum;
  /** reaction ranking type */
  ranking?: ReactionRankingEnum;
  /**
   * sort order reverse
   * @example false
   */
  reverse?: boolean;
  /**
   * @min 1
   * @max 20
   */
  limit?: number;
  next_token?: string;
  content_id?: string;
  /** @example false */
  with_activity?: boolean;
  /** @example false */
  with_profile?: boolean;
  /** @example false */
  with_child_count?: boolean;
  /** @example false */
  with_own_children?: boolean;
  /** @example false */
  with_child?: boolean;
  /**
   * @min 1
   * @max 10
   */
  child_limit?: number;
  /** 需要查询的kind，目前仅支持REPLY */
  child_kinds?: ReactionKindEnum[];
  /** 需要查询的kind，目前仅支持REPLY */
  own_child_kinds?: ReactionKindEnum[];
  /** @example false */
  with_target?: boolean;
  /** @example false */
  with_parent?: boolean;
  /**
   * 过滤掉的viewId
   * @maxItems 5
   */
  exclude_view_ids?: string[];
  /** megaphone status */
  megaphone_status?: MegaphoneStatusEnum;
}

export interface ReactionPagination {
  /**
   * limit
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * total
   * @format int32
   */
  total?: number;
  /** nextToken */
  next_token?: string;
  rows?: Reaction[];
}

export type ReactionPaginationResponse = BaseResponse & {
  data?: ReactionPagination;
};

/** reaction ranking type */
export enum ReactionRankingEnum {
  TIME = "TIME",
  HOT = "HOT",
  TOP = "TOP",
}

export interface Reaction {
  /** id */
  id?: string;
  /** user id */
  profile_id?: string;
  /** dispay content id */
  view_id?: string;
  /** chain content id */
  content_id?: string;
  /** @format int64 */
  created?: number;
  /**
   * like count
   * @format int64
   */
  like_count?: number;
  /**
   * reply count
   * @format int64
   */
  reply_count?: number;
  /**
   * 同意数
   * @format int64
   */
  upvote_count?: number;
  /**
   * 反对数
   * @format int64
   */
  downvote_count?: number;
  /** reaction kind */
  kind?: ReactionKindEnum;
  /** reaction kind */
  sub_kind?: ReactionSubKindEnum;
  /** profile info */
  profile?: Profile;
  target?: Reaction | Activity;
  /** target view id */
  target_view_id?: string;
  data?: AdditionalData;
  activity?: Feed;
  /** 最近互动列表 */
  children?: Record<string, ChildReaction[]>;
  /** 是否产生过互动 */
  owns?: Record<string, Reaction>;
  /** index id ,use mark data */
  index_id?: string;
  /** sync status enum */
  sync_status?: SyncStatus;
  /** IPFS url */
  content_uri?: string;
  /** megaphone status */
  megaphone_status?: MegaphoneStatusEnum;
  /** megaphone data */
  extra?: string;
  /** communityId */
  community_id?: string;
  /**
   * megaphone start time
   * @format int64
   */
  start_time?: number;
  /**
   * megaphone end time
   * @format int64
   */
  end_time?: number;
}

export type ReactionResponse = BaseResponse & {
  data?: Reaction;
};

export interface AdditionalData {
  /** 带有内容的reaction，比如评论/回复 */
  text?: string;
  /** content */
  content?: string;
  medias?: Media[];
  /** 场景 */
  scene?: string;
  /** 互动目标ID */
  target?: string;
}

export interface ParentReaction {
  id?: string;
  /** 行为人 */
  profile_id?: string;
  /** reaction kind */
  kind?: ReactionKindEnum;
  /** reaction kind */
  sub_kind?: ReactionSubKindEnum;
  /** 目标id */
  target_view_id?: string;
  data?: AdditionalData;
  /** @format int64 */
  created?: number;
  /** @format int64 */
  modified?: number;
  /**
   * 点赞数
   * @format int64
   */
  like_count?: number;
  /**
   * 回复数
   * @format int64
   */
  reply_count?: number;
  /**
   * 同意数
   * @format int64
   */
  upvote_count?: number;
  /**
   * 反对数
   * @format int64
   */
  downvote_count?: number;
  /** profile info */
  profile?: Profile;
}

export interface ChildReaction {
  /** id */
  id?: string;
  /** profile id */
  profile_id?: string;
  /** reaction kind */
  kind?: ReactionKindEnum;
  /** reaction kind */
  sub_kind?: ReactionSubKindEnum;
  /** 目标id */
  target_view_id?: string;
  data?: AdditionalData;
  /** @format int64 */
  created?: number;
  /** @format int64 */
  modified?: number;
  /**
   * 点赞数
   * @format int64
   */
  like_count?: number;
  /**
   * 回复数
   * @format int64
   */
  reply_count?: number;
  /**
   * 同意数
   * @format int64
   */
  upvote_count?: number;
  /**
   * 反对数
   * @format int64
   */
  downvote_count?: number;
  /** chain content id */
  content_id?: string;
  /** profile info */
  profile?: Profile;
  target?: Reaction | Activity;
  /** 是否产生过互动 */
  owns?: Record<string, Reaction>;
}

/** megaphone status */
export enum MegaphoneStatusEnum {
  NOTSTARTED = "NOTSTARTED",
  PROGRESS = "PROGRESS",
  FINISHED = "FINISHED",
}

/** query relation */
export interface ListRelationRequest {
  /**
   * query reverse relation
   * @default false
   */
  with_reverse?: boolean;
  /**
   * @min 1
   * @max 20
   */
  limit?: number;
  next_token?: string;
  /** @maxItems 20 */
  include_target_ids?: string[];
  /** @maxItems 5 */
  exclude_target_ids?: string[];
}

/** relation enum */
export enum RelationEnum {
  JOIN = "JOIN",
  FOLLOW = "FOLLOW",
  BLOCK = "BLOCK",
}

export interface Relation {
  /** id */
  id?: string;
  /** user id */
  profile_id?: string;
  /** target_id */
  target_id?: string;
  /** chain content id */
  content_id?: string;
  /**
   * chain content id
   * @format int64
   */
  relation?: number;
  /** @format int64 */
  created?: number;
  /** index id ,use mark data */
  index_id?: string;
  /** sync status enum */
  sync_status?: SyncStatus;
}

export type RelationResponse = BaseResponse & {
  data?: Relation;
};

export interface AddReportRequest {
  /** reported post id */
  target_view_id?: string;
  /** report reason */
  reason?: string;
  /** report desc */
  desc?: string;
  /** hide type */
  type?: ReportTypeEnum;
}

export type ReportResponse = BaseResponse & {
  data?: boolean;
};

/** hide type */
export enum ReportTypeEnum {
  REPORT = "REPORT",
  NOT_INTERESTED_IN = "NOT_INTERESTED_IN",
}

export interface Account {
  /** osp_address id */
  osp_address?: string;
  /** profile id */
  profile_id?: string;
  /** gas */
  type?: string;
  /** deposit code */
  code?: string;
  /** sign code */
  sign?: string;
  /** balance amount */
  balance?: Amount[];
  min_deposit_amount?: Amount;
}

export type AccountResponse = BaseResponse & {
  data?: Account;
};

export interface Amount {
  /** amount value */
  value?: string;
  /** token symbol */
  symbol?: string;
}

export interface AccountPagination {
  /**
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** @format int32 */
  total?: number;
  next_token?: string;
  rows?: Account[];
}

export type AccountPaginationResponse = BaseResponse & {
  data?: AccountPagination;
};

export interface Transaction {
  /** profile id */
  profile_id?: string;
  /** transaction hash */
  tx_hash?: string;
  /** business type. eg. topup/use/~unknown/send/receive/... */
  business_type?: string;
  /**
   * chain id
   * @format int32
   */
  chain_id?: number;
  /** usd price when create transaction */
  usd_price?: string;
  /** token symbol not unique */
  token_symbol?: string;
  /** token contract address */
  token_address?: string;
  /** token amount */
  token_amount?: string;
  /** amount */
  amount?: string;
  /** symbol */
  symbol?: string;
  /** transaction cost actual gas amount */
  used_gas?: string;
  /** transaction status, pending/finish/fail */
  status?: TransactionStatusEnum;
  /** app_id */
  app_id?: string;
  /** operation_id */
  operation_id?: string;
  /** operation_id */
  paymaster_id?: string;
  /**
   * create time
   * @format int64
   */
  created?: number;
  /**
   * modify time
   * @format int64
   */
  modified?: number;
}

export type TransactionsResponse = BaseResponse & {
  data?: Transaction;
};

export interface TransactionPagination {
  /**
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** @format int32 */
  total?: number;
  next_token?: string;
  rows?: Transaction[];
}

export type TransactionPaginationResponse = BaseResponse & {
  data?: TransactionPagination;
};

export interface ListTransactionRequest {
  /**
   * @format int32
   * @min 1
   * @max 20
   * @default 5
   */
  limit?: number;
  /** nextToken */
  next_token?: string;
}

/** transaction status */
export enum TransactionStatusEnum {
  PENDING = "PENDING",
  FINISHED = "FINISHED",
  FAILED = "FAILED",
}

/** transaction status */
export enum QueryTypeEnum {
  GAS = "GAS",
  OSP = "OSP",
}

export interface Chain {
  /**
   * chain id
   * @format int32
   */
  id?: number;
  /** chain name */
  name?: string;
  /** icon */
  icon?: string;
  /** explorer url */
  explorer_url?: string;
  /** rpc url */
  rpc_url?: string;
  /** Yes or No OSP */
  osp?: boolean;
  supported_tokens?: CurrencyToken[];
}

export interface ChainPagination {
  /**
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** @format int32 */
  total?: number;
  next_token?: string;
  rows?: Chain[];
}

export type ChainPaginationResponse = BaseResponse & {
  data?: ChainPagination;
};

export interface Price {
  /** token symbol, eg. BTC */
  symbol?: string;
  /** quote token symbol, eg. USD */
  quote?: string;
  /** the latest price */
  latest?: string;
  /**
   * rise up and fall
   * @format double
   */
  change?: number;
  /**
   * precious
   * @format int32
   */
  decimals?: number;
}

export type PriceResponse = BaseResponse & {
  data?: Price;
};

export interface PricePagination {
  /**
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** @format int32 */
  total?: number;
  next_token?: string;
  rows?: Price[];
}

export type PricePaginationResponse = BaseResponse & {
  data?: PricePagination;
};

export interface CurrencyToken {
  /** token symbol */
  symbol?: string;
  /** token name */
  name?: string;
  /** token address */
  address?: string;
  /** erc20/native */
  type?: string;
  /** icon url */
  icon?: string;
  /**
   * precious
   * @format int32
   */
  decimals?: number;
  /**
   * chain id
   * @format int32
   */
  chain_id?: number;
  /** gas/osp */
  supported_account_type?: string[];
}

/** theme info */
export interface Theme {
  /** theme id */
  id?: string;
  name?: string;
  community_id?: string;
  app_ids?: string[];
  body?: string;
  /** theme status */
  status?: ThemeStatusEnum;
}

export interface ThemePagination {
  /**
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** @format int32 */
  total?: number;
  next_token?: string;
  rows?: Theme[];
}

export type ThemePaginationResponse = BaseResponse & {
  data?: ThemePagination;
};

/** theme update only name、body、status */
export interface AddThemeRequest {
  name?: string;
  community_id?: string;
  body?: string;
  /** theme status */
  status?: ThemeStatusEnum;
}

/** theme update only name、appIds、body、status */
export interface UpdateThemeRequest {
  name?: string;
  body?: string;
  /** theme status */
  status?: ThemeStatusEnum;
}

export type ThemeResponse = BaseResponse & {
  /** theme info */
  data?: Theme;
};

/** theme status enum */
export enum ThemeStatusEnum {
  EDIT = "EDIT",
  RELEASE = "RELEASE",
  USE = "USE",
}

/** megaphone data info */
export interface Megaphone {
  /**
   * upVote count
   * @format int64
   * @default 0
   */
  upvote_count?: number;
  /**
   * like count
   * @format int64
   * @default 0
   */
  like_count?: number;
  /**
   * comments_count
   * @format int64
   * @default 0
   */
  comment_count?: number;
  /**
   * followers count
   * @format int64
   * @default 0
   */
  follower_count?: number;
  /**
   * exposure count
   * @format int64
   * @default 0
   */
  exposure_count?: number;
  /** reaction id */
  reaction_id?: string;
  /**
   * created
   * @format int64
   */
  created?: number;
  /** megaphone status */
  megaphone_status?: MegaphoneStatusEnum;
  /**
   * megaphone start time
   * @format int64
   */
  start_time?: number;
  /**
   * megaphone end time
   * @format int64
   */
  end_time?: number;
  /** megaphone duration */
  duration?: string;
  /** megaphone cost */
  amount?: string;
  /** megaphone cost currency */
  currency?: string;
  tags?: CommunityTag[];
}

export interface MegaphoneDataRequest {
  /** activity id, 帖子ID */
  activity_id?: string;
}

export type MegaphoneDataResponse = BaseResponse & {
  data?: Megaphone[];
};

export type MegaphoneResponse = BaseResponse & {
  /** megaphone data info */
  data?: Megaphone;
};

export interface Media1 {
  /** id for resource */
  id?: string;
  /** media url */
  url?: string;
  /** mimeType of media format, image/gif ,video/mp4, audio/mp3 */
  mime_type?: string;
  /** cover url */
  cover?: string;
}

/** token info */
export interface CoinToken {
  /** id */
  id?: string;
  plugin_id?: string;
  /** token name */
  name?: string;
  /** token symbol */
  symbol?: string;
  /** token banner */
  banner?: string;
  /** contract address */
  contract_address?: string;
  /**
   * Start Time for claim
   * @format int64
   */
  claim_start_time?: number;
  /**
   * complete Time for claim
   * @format int64
   */
  complete_time?: number;
  /** Currency Information for Payment */
  pay_currency?: string;
  /**
   * End Time for claim
   * @format int64
   */
  claim_end_time?: number;
  /** Initial circulatio */
  init_supply?: string;
  /** claim_supply */
  claim_supply?: string;
  /** Maximum distribution amount per individual wallet */
  limit_per_claim?: string;
  /**
   * precision
   * @format int64
   */
  precision?: number;
  /** Creator Address */
  owner_address?: string;
  /** Allocation Ratio */
  distribution?: string;
  /** Price Tiers */
  claim_price?: string;
  /** claimed amount */
  claimed_amount?: string;
  /**
   * Number of claimants
   * @format int64
   */
  claimed_user_count?: number;
  remark?: string;
  /** @format int64 */
  modified?: number;
  /** @format int64 */
  created?: number;
}

export interface GetTokenRequest {
  /**
   * @format int32
   * @min 1
   * @max 20
   * @default 5
   */
  limit?: number;
  /** nextToken */
  next_token?: string;
  /**
   * create start time condition
   * @format int64
   */
  create_start_time?: number;
  /**
   * create end time condition
   * @format int64
   */
  create_end_time?: number;
  /** token symbol */
  symbol?: string;
  /** community id */
  community_id?: string;
  /**
   * Most recently claimed user
   * @default false
   */
  with_profile?: boolean;
  /**
   * community
   * @default false
   */
  with_community?: boolean;
}

export interface TokenPagination {
  /**
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** @format int32 */
  total?: number;
  next_token?: string;
  rows?: CoinToken[];
}

export type TokenPaginationResponse = BaseResponse & {
  data?: TokenPagination;
};

export type CoinTokenResponse = BaseResponse & {
  /** token info */
  data?: CoinToken;
};

export interface UpdateTokenRequest {
  fields?: Record<string, object>;
}

/** token distribution ratio */
export interface TokenDistributionRatio {
  /**
   * distribution ratio
   * @format float
   */
  ratio?: number;
  /** distribution name */
  name?: string;
}

/** apps info */
export interface App {
  /** app id */
  id?: string;
  /** app name */
  name?: string;
  /** app description */
  description?: string;
  /** app price */
  price?: string;
  /** apps token address */
  token_address?: string;
  /** icon */
  image?: string;
  /** images or video,etc */
  medias?: Media1[];
  /** Expansions, new features and historical versions */
  ext?: AppExt[];
  /** app category */
  category?: AppCategoryEnum;
  /** schema id */
  data_schema_id?: string;
}

export interface AppPagination {
  /**
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /** @format int32 */
  total?: number;
  next_token?: string;
  rows?: App[];
}

export type AppPaginationResponse = BaseResponse & {
  data?: AppPagination;
};

/** query apps */
export interface ListAppRequest {
  /** @maxItems 20 */
  ids?: string[];
  community_id?: string;
  /** @default false */
  owned?: boolean;
  /** apps category */
  category?: AppCategoryEnum;
  /**
   * @min 1
   * @max 20
   */
  limit?: number;
  next_token?: string;
}

/** apps category */
export enum AppCategoryEnum {
  PLUGIN = "PLUGIN",
  TEMPLATE = "TEMPLATE",
}

/** apps ext */
export interface AppExt {
  /** version number */
  version?: string;
  /** version update time */
  time?: string;
  /** version update description */
  description?: string;
}

/** apps data info */
export interface AddAppDataRequest {
  /** a string of the json data that needs to be verified in json schema */
  data?: string;
  /** community id */
  community_id?: string;
}

/** apps data info */
export interface UpdateAppDataRequest {
  /** a string of the json data that needs to be verified in json schema */
  data?: string;
  /** status */
  status?: AppDataStatusEnum;
}

/** apps data info */
export interface AppData {
  /** dataId */
  id?: string;
  /** app id */
  app_id?: string;
  /** a string of the json data that needs to be verified in json schema */
  data?: string;
  /** the user id of data publisher */
  user_id?: string;
  /** community id */
  community_id?: string;
  /** status */
  status?: AppDataStatusEnum;
}

/** app data status */
export enum AppDataStatusEnum {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export type AppDataGroup = AppData[];

export type AppDataResponse = BaseResponse & {
  /** apps data info */
  data?: AppData;
};

export type AppDataGroupResponse = BaseResponse & {
  data?: AppDataGroup;
};

/** postDoc */
export interface PostDoc {
  /** 主键id */
  id?: string;
  /**
   * 创建时间
   * @format int64
   */
  created?: number;
  /** title */
  title?: string;
  /** text */
  text?: string;
  /** @format int64 */
  verb?: number;
  /** @format int64 */
  sub_verb?: number;
  user_id?: string;
  community_id?: string;
  tag?: string;
  /** @format int32 */
  status?: number;
  medias?: string;
  /** @format int64 */
  share_count?: number;
  /** @format int64 */
  like_count?: number;
  /** @format int64 */
  comment_count?: number;
  /** @format int64 */
  reply_count?: number;
  /** @format int64 */
  favorite_count?: number;
  /** @format int64 */
  view_count?: number;
  /** @format int64 */
  megaphone_count?: number;
  content?: string;
  urls?: string;
  profile_id?: string;
  hashtags?: string[];
}

/** userDoc */
export interface UserDoc {
  /** 主键id */
  id?: string;
  /**
   * 创建时间
   * @format int64
   */
  created?: number;
  /** intro */
  intro?: string;
  /** nick_name */
  nick_name?: string;
  /** unique_name */
  unique_name?: string;
  /** @format int32 */
  type?: number;
  /** avatar */
  avatar?: string;
  /** region */
  region?: string;
  /** kol_intro */
  kol_intro?: string;
  /** kol_background_url */
  kol_background_url?: string;
  /**
   * following_count
   * @format int32
   */
  following_count?: number;
  /**
   * follower_count
   * @format int32
   */
  follower_count?: number;
  /**
   * favorite_count
   * @format int32
   */
  favorite_count?: number;
  /**
   * post_count
   * @format int32
   */
  post_count?: number;
  /**
   * post_count
   * @format int32
   */
  join_count?: number;
  owner_id?: string;
  profile_id?: string;
  follow_nft?: string;
  address?: string;
}

/** userDoc */
export interface CommunityDoc {
  /** 主键id */
  id?: string;
  /**
   * 创建时间
   * @format int64
   */
  created?: number;
  /** display_name */
  display_name?: string;
  /** desc */
  desc?: string;
  /** unique_name */
  unique_name?: string;
  /** banner */
  banner?: string;
  /** user_id */
  user_id?: string;
  /** logo */
  logo?: string;
  /** join_nft */
  join_nft?: string;
  /** tags */
  tags?: string;
  address?: string;
  owner_id?: string;
  profile_id?: string;
  /** activity_tags */
  activity_tags?: string;
  /**
   * view_count
   * @format int32
   */
  view_count?: number;
  /**
   * activity_count
   * @format int32
   */
  activity_count?: number;
  /**
   * member_count
   * @format int32
   */
  member_count?: number;
}

/** hashtagDTO */
export interface HashtagDoc {
  /** hashtag */
  hashtag?: string;
}

export interface DocPagination {
  /**
   * 每次请求数
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * 返回的总页数，默认不查询总页数，返回0
   * @format int64
   */
  totalCount?: number;
  /**
   * 翻页offset
   * @format int32
   */
  offset?: number;
  rows?: (UserDoc | PostDoc | CommunityDoc | HashtagDoc)[];
}

export interface DocPaginationRequest {
  /** search keyWords */
  keyWords?: string;
  /** zone */
  zone?: string;
  /**
   * nextToken for pagination
   * @format int32
   */
  page?: number;
  /**
   * limit for pagination
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * searchType
   * @format int32
   */
  search_type?: number;
}

export type DocPaginationResponse = BaseResponse & {
  data?: DocPagination;
};

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "https://{region}-{environment}.opensocial.{domain}/v2/";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== "string" ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
            ? JSON.stringify(property)
            : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Open Social API
 * @version 2.0.0
 * @baseUrl https://{region}-{environment}.opensocial.{domain}/v2/
 *
 * The Contract API for Open Social Project
 */
export class Osp<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  tx = {
    /**
     * @description ## 根据签名发送交易，测试使用
     *
     * @tags Transaction
     * @name TxBroadcast
     * @summary /broadcast
     * @request POST:/tx/broadcast
     * @secure
     */
    txBroadcast: (data: BroadcastRequest, params: RequestParams = {}) =>
      this.request<BroadcastResponse, any>({
        path: `/tx/broadcast`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ## 可用于客户端先监听到数据或者补数据使用
     *
     * @tags Transaction
     * @name TxStore
     * @summary /tx/store
     * @request POST:/tx/store
     * @secure
     */
    txStore: (data: SyncRequest, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/tx/store`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description sync operate
     *
     * @tags Transaction
     * @name Sync
     * @summary /tx/sync
     * @request POST:/tx/sync
     * @secure
     */
    sync: (data: SyncRequest, params: RequestParams = {}) =>
      this.request<BaseResponse, void>({
        path: `/tx/sync`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  mint = {
    /**
     * @description mint a slot nft for user to create community, only for test
     *
     * @tags Faucet
     * @name MintSlotNft
     * @summary /mint/slot_nft
     * @request POST:/mint/slot_nft
     * @secure
     */
    mintSlotNft: (
      data: {
        address: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TransactionResponse, any>({
        path: `/mint/slot_nft`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description mint community whitelist creator, only for test
     *
     * @tags Faucet
     * @name MintCommunityWhitelistCreator
     * @summary /mint/community_whitelist_creator
     * @request POST:/mint/community_whitelist_creator
     * @secure
     */
    mintCommunityWhitelistCreator: (
      data: {
        address: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TransactionResponse, any>({
        path: `/mint/community_whitelist_creator`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  meta = {
    /**
     * @description get nft by token id
     *
     * @tags NFT
     * @name GetNftByTokenId
     * @summary /meta/{type}/{token_id}
     * @request GET:/meta/{type}/{token_id}
     * @secure
     */
    getNftByTokenId: (tokenId: string, type: BaseMetaTypeEnum, params: RequestParams = {}) =>
      this.request<NFT, any>({
        path: `/meta/${type}/${tokenId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description get join nft by token id, invoke by JoinNFT contract
     *
     * @tags NFT
     * @name GetJoinNftByCommunityIdAndTokenId
     * @summary /meta/{community_id}/join/{token_id}
     * @request GET:/meta/{community_id}/join/{token_id}
     * @secure
     */
    getJoinNftByCommunityIdAndTokenId: (communityId: string, tokenId: string, params: RequestParams = {}) =>
      this.request<NFT, any>({
        path: `/meta/${communityId}/join/${tokenId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description get join nft by token id, invoke by JoinNFT contract
     *
     * @tags NFT
     * @name GetFollowNftByProfileIdAndTokenId
     * @summary /meta/{profile_id}/follow/{token_id}
     * @request GET:/meta/{profile_id}/follow/{token_id}
     * @secure
     */
    getFollowNftByProfileIdAndTokenId: (profileId: string, tokenId: string, params: RequestParams = {}) =>
      this.request<NFT, any>({
        path: `/meta/${profileId}/follow/${tokenId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  erc4337 = {
    /**
     * @description get paymaster and data by user operation
     *
     * @tags ERC4337
     * @name FillUserOperation
     * @summary /erc4337/fill
     * @request POST:/erc4337/fill
     * @secure
     */
    fillUserOperation: (data: UserOperation, params: RequestParams = {}) =>
      this.request<FillUserOperationResponse, any>({
        path: `/erc4337/fill`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description estimate gas by user operation
     *
     * @tags ERC4337
     * @name EstimateUserOperation
     * @summary /erc4337/estimate
     * @request POST:/erc4337/estimate
     * @secure
     */
    estimateUserOperation: (data: UserOperation, params: RequestParams = {}) =>
      this.request<EstimateUserOperationResponse, any>({
        path: `/erc4337/estimate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  auth = {
    /**
     * @description get challenge by address
     *
     * @tags Authentication
     * @name GetChallenge
     * @summary /auth/challenge
     * @request GET:/auth/challenge
     */
    getChallenge: (
      query: {
        /**
         * wallet address
         * @example "0xD8805CEcaD06E93Fc0976Ac8d094beeEA269ae37"
         */
        address: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ChallengeResponse, void>({
        path: `/auth/challenge`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description login by challenge
     *
     * @tags Authentication
     * @name Authenticate
     * @summary /auth/login
     * @request POST:/auth/login
     */
    authenticate: (data: AuthRequest, params: RequestParams = {}) =>
      this.request<TokenResponse, void>({
        path: `/auth/login`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description verify access token
     *
     * @tags Authentication
     * @name Verify
     * @summary /auth/verify
     * @request POST:/auth/verify
     */
    verify: (
      query: {
        /**
         * verify access token
         * @example ""
         */
        access_token: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, void>({
        path: `/auth/verify`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description refresh access token
     *
     * @tags Authentication
     * @name RefreshToken
     * @summary /auth/refresh
     * @request POST:/auth/refresh
     */
    refreshToken: (
      query: {
        /**
         * refresh access token
         * @example ""
         */
        refresh_token: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TokenResponse, void>({
        path: `/auth/refresh`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description get id_token by accessToken
     *
     * @tags Authentication
     * @name IdToken
     * @summary /auth/id_token
     * @request GET:/auth/id_token
     * @secure
     */
    idToken: (params: RequestParams = {}) =>
      this.request<IdTokenResponse, void>({
        path: `/auth/id_token`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  owners = {
    /**
     * @description query authorize by OSPAddress
     *
     * @tags owner
     * @name ListAuthorizeOwners
     * @summary /owners
     * @request GET:/owners
     * @secure
     */
    listAuthorizeOwners: (
      query?: {
        /** eoa_address query bind OSPAccount */
        eoa_address?: string;
        /** osp_address query bind eoaAccount */
        osp_address?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<OwnerPaginationResponse, any>({
        path: `/owners`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description query authorize by OSPAddress
     *
     * @tags owner
     * @name GetOwnerByEoaAddress
     * @summary /owners/{eoaAddress}
     * @request GET:/owners/{eoaAddress}
     * @secure
     */
    getOwnerByEoaAddress: (eoaAddress: string, params: RequestParams = {}) =>
      this.request<OwnerResponse, any>({
        path: `/owners/${eoaAddress}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  activities = {
    /**
     * No description
     *
     * @tags Activity
     * @name GetActivities
     * @summary /activities
     * @request GET:/activities
     * @secure
     */
    getActivities: (
      query: {
        getActivitiesRequest: GetActivitiesRequest;
      },
      params: RequestParams = {},
    ) =>
      this.request<ActivityPaginationResponse, any>({
        path: `/activities`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ### 该接口同时支持链下发帖和dispatcher模式发帖，发布帖子/评论/转发前都需要进行内容元数据的构建，构建的内容标准需要遵循 Metadata structure的定义，最终将json文件上传到**IPFS**作为content_uri的内容，为了保持统一，不需要上链同样需要进行这一步操作
     *
     * @tags Activity
     * @name AddActivity
     * @summary /activities
     * @request POST:/activities
     * @secure
     */
    addActivity: (data: AddActivityRequest, params: RequestParams = {}) =>
      this.request<ActivityResponse, any>({
        path: `/activities`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description get activity by id
     *
     * @tags Activity
     * @name GetActivity
     * @summary /activities/{activity_id}
     * @request GET:/activities/{activity_id}
     * @secure
     */
    getActivity: (activityId: string, params: RequestParams = {}) =>
      this.request<ActivityResponse, BaseResponse>({
        path: `/activities/${activityId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description put activity by id
     *
     * @tags Activity
     * @name UpdateActivityById
     * @summary /activities/{activity_id}
     * @request PUT:/activities/{activity_id}
     * @secure
     */
    updateActivityById: (activityId: string, data: UpdateActivityRequest, params: RequestParams = {}) =>
      this.request<BaseResponse, BaseResponse>({
        path: `/activities/${activityId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Activity
     * @name StopActivity
     * @summary /activities/{activity_id}
     * @request DELETE:/activities/{activity_id}
     * @secure
     */
    stopActivity: (activityId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, BaseResponse>({
        path: `/activities/${activityId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description get activity by contentId
     *
     * @tags Activity
     * @name GetActivityByContentId
     * @summary /activities/content_id/{content_id}
     * @request GET:/activities/content_id/{content_id}
     * @secure
     */
    getActivityByContentId: (
      contentId: string,
      query: {
        /** query profileId */
        profile_id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ActivityResponse, BaseResponse>({
        path: `/activities/content_id/${contentId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  feed = {
    /**
     * @description /feed/{feed_id}
     *
     * @tags Feed
     * @name GetFeed
     * @request GET:/feed/{feed_id}
     * @secure
     */
    getFeed: (
      feedId: string,
      query: {
        enrich_option: EnrichOption;
      },
      params: RequestParams = {},
    ) =>
      this.request<FeedResponse, any>({
        path: `/feed/${feedId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description /feed/{feed_type}/{feed_key}
     *
     * @tags Feed
     * @name ListFeed
     * @request GET:/feed/{feed_type}/{feed_key}
     * @secure
     */
    listFeed: (
      feedType: string,
      feedKey: string,
      query: {
        listFeedRequest: ListFeedRequest;
      },
      params: RequestParams = {},
    ) =>
      this.request<FeedPaginationResponse, any>({
        path: `/feed/${feedType}/${feedKey}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  profiles = {
    /**
     * No description
     *
     * @tags Profile
     * @name ListProfile
     * @summary /profiles
     * @request GET:/profiles
     * @secure
     */
    listProfile: (
      query?: {
        /** request info */
        profileRequest?: ListProfileRequest;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProfilePaginationResponse, any>({
        path: `/profiles`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description get profile by id
     *
     * @tags Profile
     * @name GetProfileById
     * @summary /profiles/{profile_id}
     * @request GET:/profiles/{profile_id}
     * @secure
     */
    getProfileById: (profileId: string, params: RequestParams = {}) =>
      this.request<ProfileResponse, any>({
        path: `/profiles/${profileId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description modify profile
     *
     * @tags Profile
     * @name UpdateProfile
     * @summary /profiles/{profile_id}
     * @request PUT:/profiles/{profile_id}
     * @secure
     */
    updateProfile: (profileId: string, data: UpdateProfileRequest, params: RequestParams = {}) =>
      this.request<ProfileResponse, any>({
        path: `/profiles/${profileId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description /profiles/{profile_id}/stories
     *
     * @tags Story
     * @name ListDynamic
     * @request GET:/profiles/{profile_id}/stories
     * @secure
     */
    listDynamic: (
      profileId: string,
      query: {
        /** 查询动态列表 */
        listDynamicRequest: ListStoryRequest;
      },
      params: RequestParams = {},
    ) =>
      this.request<StoryPaginationResponse, any>({
        path: `/profiles/${profileId}/stories`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Profile
     * @name GetByHandle
     * @summary /profiles/handle/{profile_handle}
     * @request GET:/profiles/handle/{profile_handle}
     * @secure
     */
    getByHandle: (profileHandle: string, params: RequestParams = {}) =>
      this.request<ProfileResponse, any>({
        path: `/profiles/handle/${profileHandle}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description get own assets by profile
     *
     * @tags Asset
     * @name GetAssetsByProfileId
     * @summary /profiles/{profile_id}/assets
     * @request GET:/profiles/{profile_id}/assets
     * @secure
     */
    getAssetsByProfileId: (
      profileId: string,
      query?: {
        /** asset type, eg. nft,sbt */
        type?: AssetTypeEnum;
        /**
         * limit count
         * @example 10
         */
        limit?: number;
        /** next token for page */
        next_token?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AssetPaginationResponse, any>({
        path: `/profiles/${profileId}/assets`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  communities = {
    /**
     * @description query community by param
     *
     * @tags Community
     * @name ListCommunity
     * @summary /communities
     * @request GET:/communities
     * @secure
     */
    listCommunity: (
      query?: {
        /** request info */
        communityRequest?: ListCommunityRequest;
      },
      params: RequestParams = {},
    ) =>
      this.request<CommunityPaginationResponse, any>({
        path: `/communities`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description query community by id
     *
     * @tags Community
     * @name GetCommunityById
     * @summary /communities/{community_id}
     * @request GET:/communities/{community_id}
     * @secure
     */
    getCommunityById: (
      communityId: string,
      query?: {
        enrich_option?: CommunityEnrichOption;
      },
      params: RequestParams = {},
    ) =>
      this.request<CommunityResponse, any>({
        path: `/communities/${communityId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Community
     * @name UpdateCommunityById
     * @summary /communities/{community_id}
     * @request PUT:/communities/{community_id}
     * @secure
     */
    updateCommunityById: (communityId: string, data: UpdateCommunityRequest, params: RequestParams = {}) =>
      this.request<CommunityResponse, any>({
        path: `/communities/${communityId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description query community by name
     *
     * @tags Community
     * @name GetCommunityByHandle
     * @summary /communities/handle/{community_handle}
     * @request GET:/communities/handle/{community_handle}
     * @secure
     */
    getCommunityByHandle: (
      communityHandle: string,
      query?: {
        enrich_option?: CommunityEnrichOption;
      },
      params: RequestParams = {},
    ) =>
      this.request<CommunityResponse, any>({
        path: `/communities/handle/${communityHandle}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description update community domain by id
     *
     * @tags Community
     * @name UpdateDomainById
     * @summary /communities/{community_id}/domain
     * @request POST:/communities/{community_id}/domain
     * @secure
     */
    updateDomainById: (
      communityId: string,
      query: {
        /**
         * domain
         * @example "abc"
         */
        domain: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/communities/${communityId}/domain`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description query communities tags
     *
     * @tags Community
     * @name GetCommunityTags
     * @summary /communities/config/tags
     * @request GET:/communities/configs/tags
     * @secure
     */
    getCommunityTags: (params: RequestParams = {}) =>
      this.request<CommunityTagPaginationResponse, any>({
        path: `/communities/configs/tags`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  reactions = {
    /**
     * @description add reaction
     *
     * @tags Reaction
     * @name AddReaction
     * @summary /reactions
     * @request POST:/reactions
     * @secure
     */
    addReaction: (data: AddReactionRequest, params: RequestParams = {}) =>
      this.request<ReactionResponse, any>({
        path: `/reactions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description get reaction by id
     *
     * @tags Reaction
     * @name GetReaction
     * @summary /reactions/{id}
     * @request GET:/reactions/{id}
     * @secure
     */
    getReaction: (id: string, params: RequestParams = {}) =>
      this.request<ReactionResponse, any>({
        path: `/reactions/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description delete reaction by id
     *
     * @tags Reaction
     * @name DeleteReaction
     * @summary /reactions/{id}
     * @request DELETE:/reactions/{id}
     * @secure
     */
    deleteReaction: (id: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/reactions/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reaction
     * @name GetReactions
     * @summary /reactions/{lookup_attr}/{lookup_value}/{kind}
     * @request GET:/reactions/{lookup_attr}/{lookup_value}/{kind}
     * @secure
     */
    getReactions: (
      lookupAttr: string,
      lookupValue: string,
      kind: ReactionKindEnum,
      query: {
        /** reaction request */
        listReactionRequest: ListReactionRequest;
      },
      params: RequestParams = {},
    ) =>
      this.request<ReactionPaginationResponse, any>({
        path: `/reactions/${lookupAttr}/${lookupValue}/${kind}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reaction
     * @name DeleteReactionByKind
     * @summary /reactions/{lookup_attr}/{lookup_value}/{kind}
     * @request DELETE:/reactions/{lookup_attr}/{lookup_value}/{kind}
     * @secure
     */
    deleteReactionByKind: (
      lookupAttr: string,
      lookupValue: string,
      kind: ReactionKindEnum,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/reactions/${lookupAttr}/${lookupValue}/${kind}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  relations = {
    /**
     * No description
     *
     * @tags Relation
     * @name AddProfileFollow
     * @summary /relations/profiles/{profile_id}/following
     * @request POST:/relations/profiles/{profile_id}/following
     * @secure
     */
    addProfileFollow: (profileId: string, params: RequestParams = {}) =>
      this.request<RelationResponse, any>({
        path: `/relations/profiles/${profileId}/following`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Relation
     * @name DeleteProfileFollow
     * @summary /relations/profiles/{profile_id}/following
     * @request DELETE:/relations/profiles/{profile_id}/following
     * @secure
     */
    deleteProfileFollow: (profileId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/relations/profiles/${profileId}/following`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Relation
     * @name GetProfileFollowing
     * @summary /relations/profiles/{profile_id}/following
     * @request GET:/relations/profiles/{profile_id}/following
     * @secure
     */
    getProfileFollowing: (
      profileId: string,
      query?: {
        /** query request body */
        filter?: ListRelationRequest;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProfilePaginationResponse, any>({
        path: `/relations/profiles/${profileId}/following`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Relation
     * @name ListProfileFollowers
     * @summary /relations/profiles/{profile_id}/followers
     * @request GET:/relations/profiles/{profile_id}/followers
     * @secure
     */
    listProfileFollowers: (
      profileId: string,
      query?: {
        /** query request body */
        filter?: ListRelationRequest;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProfilePaginationResponse, any>({
        path: `/relations/profiles/${profileId}/followers`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Relation
     * @name GetProfileJoining
     * @summary /relations/profiles/{profile_id}/joining
     * @request GET:/relations/profiles/{profile_id}/joining
     * @secure
     */
    getProfileJoining: (
      profileId: string,
      query?: {
        /** query request body */
        filter?: ListRelationRequest;
      },
      params: RequestParams = {},
    ) =>
      this.request<CommunityPaginationResponse, any>({
        path: `/relations/profiles/${profileId}/joining`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Relation
     * @name ListCommunityMember
     * @summary /relations/communities/{community_id}/members
     * @request GET:/relations/communities/{community_id}/members
     * @secure
     */
    listCommunityMember: (
      communityId: string,
      query?: {
        /** query request body */
        filter?: ListRelationRequest;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProfilePaginationResponse, any>({
        path: `/relations/communities/${communityId}/members`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  report = {
    /**
     * @description report post
     *
     * @tags Report
     * @name AddReport
     * @summary /report
     * @request POST:/report
     * @secure
     */
    addReport: (data: AddReportRequest, params: RequestParams = {}) =>
      this.request<ReportResponse, any>({
        path: `/report`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  ipfs = {
    /**
     * @description upload ipfs
     *
     * @tags Common
     * @name UploadIpfs
     * @summary /ipfs/upload
     * @request POST:/ipfs/upload
     * @secure
     */
    uploadIpfs: (
      data: {
        /** upload content body to ipfs for generate content uri cid */
        content?: string;
        /**
         * media file to upload
         * @format binary
         */
        media?: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, void>({
        path: `/ipfs/upload`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description pin ipfs file
     *
     * @tags Common
     * @name PinIpfs
     * @summary /ipfs/pin/{cid}
     * @request POST:/ipfs/pin/{cid}
     * @secure
     */
    pinIpfs: (cid: string, params: RequestParams = {}) =>
      this.request<BaseResponse, void>({
        path: `/ipfs/pin/${cid}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  accounts = {
    /**
     * @description fetch gas account list info
     *
     * @tags Account
     * @name GetAccountList
     * @summary /accounts
     * @request GET:/accounts
     * @secure
     */
    getAccountList: (params: RequestParams = {}) =>
      this.request<AccountPaginationResponse, void>({
        path: `/accounts`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description fetch gas account info
     *
     * @tags Account
     * @name GetAccount
     * @summary /accounts/{type}
     * @request GET:/accounts/{type}
     * @secure
     */
    getAccount: (type: QueryTypeEnum, params: RequestParams = {}) =>
      this.request<AccountResponse, void>({
        path: `/accounts/${type}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description fetch gas transaction list
     *
     * @tags Account
     * @name ListAccountTransactions
     * @summary /accounts/{type}/transactions
     * @request GET:/accounts/{type}/transactions
     * @secure
     */
    listAccountTransactions: (
      type: QueryTypeEnum,
      query?: {
        /**
         * list request
         * @example "gas"
         */
        query?: ListTransactionRequest;
      },
      params: RequestParams = {},
    ) =>
      this.request<TransactionPaginationResponse, void>({
        path: `/accounts/${type}/transactions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description code verify
     *
     * @tags Account
     * @name CodeVerify
     * @summary /accounts/{type}/verify/{code}
     * @request GET:/accounts/{type}/verify/{code}
     * @secure
     */
    codeVerify: (
      type: QueryTypeEnum,
      code: string,
      query: {
        /**
         * aa account address
         * @example "0x03036c5e70ca92b5ef69969dc99a9e0f009e4393"
         */
        address: string;
        /**
         * account sign
         * @example "sign"
         */
        sign: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/accounts/${type}/verify/${code}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  transactions = {
    /**
     * @description fetch gas account list info
     *
     * @tags transactions
     * @name GetTransactions
     * @summary /transactions
     * @request GET:/transactions
     * @secure
     */
    getTransactions: (
      query: {
        /**
         * operation_id
         * @example "QmUNLLsPACCz1vLxQVkXqqLX5R1X345qqfHbsf67hvA3Nn"
         */
        operation_id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TransactionsResponse, void>({
        path: `/transactions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  configs = {
    /**
     * @description get chain config
     *
     * @tags Config
     * @name ListChains
     * @summary /configs/chains
     * @request GET:/configs/chains
     * @secure
     */
    listChains: (params: RequestParams = {}) =>
      this.request<ChainPaginationResponse, void>({
        path: `/configs/chains`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description get all symbol price
     *
     * @tags Config
     * @name ListPrice
     * @summary /configs/prices
     * @request GET:/configs/prices
     * @secure
     */
    listPrice: (params: RequestParams = {}) =>
      this.request<PricePaginationResponse, void>({
        path: `/configs/prices`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description get all symbol price
     *
     * @tags Config
     * @name GetPrice
     * @summary /configs/price/{symbol}
     * @request GET:/configs/price/{symbol}
     * @secure
     */
    getPrice: (
      symbol: string,
      query?: {
        /**
         * symbol quote
         * @example "ETH"
         */
        quote?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PriceResponse, void>({
        path: `/configs/price/${symbol}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  themes = {
    /**
     * @description query apps param
     *
     * @tags Theme
     * @name ListTheme
     * @summary /themes
     * @request GET:/themes
     * @secure
     */
    listTheme: (
      communityId: string,
      query: {
        /**
         * Whether to query only the ones in use
         * @example false
         */
        only_use: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ThemePaginationResponse, any>({
        path: `/themes`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description addTheme
     *
     * @tags Theme
     * @name AddTheme
     * @summary /themes
     * @request POST:/themes
     * @secure
     */
    addTheme: (data: AddThemeRequest, params: RequestParams = {}) =>
      this.request<ThemeResponse, any>({
        path: `/themes`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description put theme by id
     *
     * @tags Theme
     * @name UpdateThemeById
     * @summary /theme/{id}
     * @request PUT:/themes/{id}
     * @secure
     */
    updateThemeById: (id: string, data: UpdateThemeRequest, params: RequestParams = {}) =>
      this.request<BaseResponse, BaseResponse>({
        path: `/themes/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  megaphones = {
    /**
     * @description query megaphones of activityId
     *
     * @tags megaphone
     * @name ListMegaphones
     * @summary /megaphones
     * @request GET:/megaphones
     * @secure
     */
    listMegaphones: (
      query?: {
        /** request */
        megaphoneDataRequest?: MegaphoneDataRequest;
      },
      params: RequestParams = {},
    ) =>
      this.request<MegaphoneDataResponse, any>({
        path: `/megaphones`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description get by megaphone id
     *
     * @tags megaphone
     * @name GetMegaphoneById
     * @summary /megaphones/{id}
     * @request GET:/megaphones/{id}
     * @secure
     */
    getMegaphoneById: (id: string, params: RequestParams = {}) =>
      this.request<MegaphoneResponse, any>({
        path: `/megaphones/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  tokens = {
    /**
     * @description query tokens by param ---can only query the logged-in user own
     *
     * @tags Plugin
     * @name GetTokens
     * @summary /tokens
     * @request GET:/tokens
     * @secure
     */
    getTokens: (
      query: {
        getTokenRequest: GetTokenRequest;
      },
      params: RequestParams = {},
    ) =>
      this.request<TokenPaginationResponse, any>({
        path: `/tokens`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description get token by id
     *
     * @tags Plugin
     * @name GetTokenById
     * @summary /tokens/{token_id}
     * @request GET:/tokens/{token_id}
     * @secure
     */
    getTokenById: (tokenId: string, params: RequestParams = {}) =>
      this.request<CoinTokenResponse, any>({
        path: `/tokens/${tokenId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description modify token
     *
     * @tags Plugin
     * @name UpdateToken
     * @summary /tokens/{token_id}
     * @request PUT:/tokens/{token_id}
     * @secure
     */
    updateToken: (tokenId: string, data: UpdateTokenRequest, params: RequestParams = {}) =>
      this.request<CoinTokenResponse, any>({
        path: `/tokens/${tokenId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description get token by contract address
     *
     * @tags Plugin
     * @name GetTokenByAddress
     * @summary /tokens/address/{address}
     * @request GET:/tokens/address/{address}
     * @secure
     */
    getTokenByAddress: (address: string, params: RequestParams = {}) =>
      this.request<CoinTokenResponse, any>({
        path: `/tokens/address/${address}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  apps = {
    /**
     * @description query apps param
     *
     * @tags App
     * @name GetAppList
     * @summary /apps
     * @request GET:/apps
     * @secure
     */
    getAppList: (
      query?: {
        /** request info */
        appsRequest?: ListAppRequest;
      },
      params: RequestParams = {},
    ) =>
      this.request<AppPaginationResponse, any>({
        path: `/apps`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description add the data of app
     *
     * @tags AppData
     * @name AddAppData
     * @summary /apps/{app_id}/datas
     * @request POST:/apps/{app_id}/datas
     * @secure
     */
    addAppData: (appId: string, data: AddAppDataRequest, params: RequestParams = {}) =>
      this.request<AppDataResponse, any>({
        path: `/apps/${appId}/datas`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description update the data of app
     *
     * @tags AppData
     * @name UpdateAppData
     * @summary /apps/{app_id}/datas/{data_id}
     * @request PUT:/apps/{app_id}/datas/{data_id}
     * @secure
     */
    updateAppData: (appId: string, dataId: string, data: UpdateAppDataRequest, params: RequestParams = {}) =>
      this.request<AppDataResponse, any>({
        path: `/apps/${appId}/datas/${dataId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description delate app data
     *
     * @tags AppData
     * @name DeleteAppData
     * @summary /apps/{app_id}/datas/{data_id}
     * @request DELETE:/apps/{app_id}/datas/{data_id}
     * @secure
     */
    deleteAppData: (appId: string, dataId: string, params: RequestParams = {}) =>
      this.request<BaseResponse, any>({
        path: `/apps/${appId}/datas/${dataId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description query app data
     *
     * @tags AppData
     * @name GetLatestAppData
     * @summary /apps/{app_id}/datas/latest
     * @request GET:/apps/{app_id}/datas/latest
     * @secure
     */
    getLatestAppData: (
      appId: string,
      query: {
        /**
         * query by community id
         * @example ""
         */
        community_id: string;
        /**
         * whether to query deleted data,then filtered the deleted data
         * @example "all"
         */
        filter?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AppDataResponse, any>({
        path: `/apps/${appId}/datas/latest`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description batch get the active app data
     *
     * @tags AppData
     * @name GroupAppData
     * @summary /apps/datas/group
     * @request GET:/apps/datas/group
     * @secure
     */
    groupAppData: (
      query: {
        /**
         * query the active data by app ids
         * @example ""
         */
        app_ids: string[];
        /**
         * query by community id
         * @example ""
         */
        community_id: string;
        /**
         * whether to query deleted data,then filtered the deleted data
         * @example "all"
         */
        filter?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AppDataGroupResponse, any>({
        path: `/apps/datas/group`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  search = {
    /**
     * @description list
     *
     * @tags Search
     * @name List
     * @summary /search
     * @request GET:/search
     * @secure
     */
    list: (
      query?: {
        /** request info */
        searchRequest?: DocPaginationRequest;
      },
      params: RequestParams = {},
    ) =>
      this.request<DocPaginationResponse, any>({
        path: `/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
